
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1591011570461",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "8418",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "64",
    "height": "64"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 0v82.747475H941.252525v858.50505H512v82.747475H1024V0z",
        "fill": "#8a8a8a",
        "p-id": "8419"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M82.747475 941.252525V82.747475h429.252525V0H0v1024h512v-82.747475z",
        "fill": "#8a8a8a",
        "p-id": "8420"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M272.948752 645.581317h1.634262c21.460558 0 38.849939-17.530053 38.84994-38.885107v-169.139976c0-21.321956-17.530053-38.849939-38.84994-38.849939h-1.634262c-21.460558 0-38.849939 17.530053-38.84994 38.849939v169.139976c-0.002069 21.355055 17.389382 38.885107 38.84994 38.885107zM332.040792 671.911564c0 19.720792 16.034392 35.616582 35.755184 35.616581h38.15486v91.440097c0 21.458489 17.391451 38.852008 38.885107 38.852009h1.599095c21.493657 0 38.885107-17.530053 38.885107-38.852009v-91.440097h53.388671v91.440097c0 21.458489 17.530053 38.852008 38.852008 38.852009h1.634263c21.458489 0 38.852008-17.530053 38.852008-38.852009v-91.440097h38.190028c19.547022 0 35.720016-15.89579 35.720016-35.616581V404.966141H332.040792v266.945423zM692.654287 388.793147c0.244105-3.547798 0.521309-7.060428 0.521309-10.608226 0-57.875653-36.938473-108.413673-91.580768-135.194893l30.329018-46.849551c1.878368-2.852719 1.077786-6.921826-1.913535-8.835362-2.991321-2.052137-6.921826-1.216388-8.835362 1.913536l-31.512307 48.345212c-23.512695-9.633875-49.87604-15.06004-77.596444-15.060041-27.861075 0-54.189253 5.426166-77.701947 15.060041l-31.406805-48.345212c-1.878368-3.129923-5.947475-3.965673-8.938795-1.913536-2.991321 1.913535-3.827071 5.982642-1.913536 8.835362l30.293851 46.849551c-54.607127 26.78122-91.578699 77.317172-91.578699 135.194893 0 3.547798 0.277204 7.060428 0.556476 10.608226h361.277544z m-96.90143-96.72766c9.669042 0 17.391451 7.581737 17.39145 17.25078a17.331459 17.331459 0 0 1-17.39145 17.389381 17.352145 17.352145 0 0 1-17.389382-17.389381c0-9.669042 7.753438-17.25078 17.389382-17.25078z m-167.507782 0c9.633875 0 17.391451 7.581737 17.39145 17.25078a17.352145 17.352145 0 0 1-17.39145 17.389381 17.352145 17.352145 0 0 1-17.389382-17.389381c0-9.669042 7.755507-17.25078 17.389382-17.25078zM749.414917 645.581317h1.636331c21.458489 0 38.849939-17.530053 38.84994-38.885107v-169.139976c0-21.321956-17.494885-38.849939-38.84994-38.849939h-1.636331c-21.460558 0-38.849939 17.530053-38.849939 38.849939v169.139976c0.002069 21.355055 17.530053 38.885107 38.849939 38.885107z",
        "fill": "#8a8a8a",
        "p-id": "8421"
      }
    }
  ]
})
    }
  